export const PATH = '/edition/service';
